import { render, staticRenderFns } from "./daily-cargo-table.vue?vue&type=template&id=cbd8ab92"
import script from "./daily-cargo-table.vue?vue&type=script&lang=js"
export * from "./daily-cargo-table.vue?vue&type=script&lang=js"
import style0 from "./daily-cargo-table.vue?vue&type=style&index=0&id=cbd8ab92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports